import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import KeyDecisionEvent from "../event/KeyDecisionEvent";
import KeyDecisionInteractionEvent from "../event/KeyDecisionInteractionEvent";

export default class KeyDecisionAvailableCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);

        this._handleConfirmKeyDecisionSeenBound = this._handleConfirmKeyDecisionSeen.bind(this);
    }

    execute(evt) {
        /** @type {KeyDecisionEvent} */
        const data = evt.params.data;
        const keyDecision = data.keyDecision;
        const delay = data.delay || 0;

        this._dispatcher.addEventListener(KeyDecisionInteractionEvent.REQUEST_KEY_DECISION, this._handleConfirmKeyDecisionSeenBound);

        const transitionInDuration = 450;
        this._screenSkin = this.openPopup(SkinKeyRegistry.KEY_DECISION_AVAILABLE_SCREEN_SKIN, null, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(delay, transitionInDuration, createjs.Ease.sineInOut),
            priority: 2,
            needsOverlay: false,
        }, {
            keyDecision,
            transitionInDuration,
        });
    }

    _handleConfirmKeyDecisionSeen() {
        this._dispatcher.removeEventListener(KeyDecisionInteractionEvent.REQUEST_KEY_DECISION, this._handleConfirmKeyDecisionSeenBound);

        
        this.closePopup(this._screenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        });

        this._screenSkin = null;
    }
}